import React from "react";
import { withWrapper } from "create-react-server/wrapper";

import YandexMap from "components/YandexMap/YandexMap";
import Search from "components/Search/Search";
import ControlsContainer from "components/ControlsContainer/ControlsContainer";
import LibraryCard from "components/LibraryCard/LibraryCard";

const Library = props => (
  <div className="content">
    <Search />
    <ControlsContainer />
    <YandexMap />
    <LibraryCard />
  </div>
);

export default withWrapper(Library);



// WEBPACK FOOTER //
// ./src/containers/Library/Library.js